import dayjs from "@lib/dayjs";
import { NavLink } from "react-router-dom";
// @ts-ignore
import fallbackProfileImg from "@assets/images/emptyUser.png";
import { EnumJobTrackerStatus } from "@utils/constants";
import { ArrowRight } from "lucide-react";

const CandidateRowCard = ({ data }) => {
  const candidate = data?.candidate || {};
  const candidateId = data?._id;
  const fullName =
    `${candidate?.firstName || ""} ${candidate?.lastName || ""}`.trim() || "-";
  const statusText = candidate?.status || "-";
  const isUnavailable = statusText?.toLowerCase?.() === "unavailable";
  const latestTracker = data?.latestTrackerDetails;
  const latestActivityJobTitle = data?.latestActivityJob?.title || "-";
  const trackerStatus = latestTracker?.status;

  const renderTrackerMessage = () => {
    if (!trackerStatus) return "No recent activity.";
    const title = latestActivityJobTitle || "-";
    switch (trackerStatus) {
      case EnumJobTrackerStatus.APPLIED:
        return (
          <>
            Candidate applied for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.APPLICATIONVIEWED:
        return (
          <>
            Application viewed for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.INTERVIEWSCHEDULED:
        return (
          <>
            Interview scheduled for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.CANDIDATEPLACED:
        return (
          <>
            Candidate placed for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.SHORTLIST:
        return (
          <>
            Candidate shortlisted for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.DECLINE:
        return (
          <>
            Candidate declined for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.SUBMITOFFER:
        return (
          <>
            Offer submitted for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.JOBCLOSE:
        return (
          <>
            Job closed for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.SUBMIT_TO_HIRING_COMPANY:
        return (
          <>
            Candidate submitted to hiring company for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.SEND_MEETING_INVITATION:
        return (
          <>
            Meeting invitation sent for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.SHORTLIST_BY_HIRING_COMPANY:
        return (
          <>
            Shortlisted by hiring company for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.DECLINE_BY_HIRING_COMPANY:
        return (
          <>
            Declined by hiring company for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.APPLICATION_VIEWED_BY_HIRING_COMPANY:
        return (
          <>
            Application viewed by hiring company for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.INTERVIEW_MEETING_CLOSED:
        return (
          <>
            Interview meeting closed for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.OFFER_ACCEPTED:
        return (
          <>
            Offer accepted for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.OFFER_DECLINED:
        return (
          <>
            Offer declined for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.REQUEST_EXCLUSIVE_REPRESENTATION:
        return (
          <>
            Exclusive representation requested for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      case EnumJobTrackerStatus.CANDIDATE_HAS_JOINED_HIRING_COMPANY:
        return (
          <>
            Candidate joined hiring company for the position titled{" "}
            <span className="font-bold">{title}</span>
          </>
        );
      default:
        return <>Latest Activity: {trackerStatus}</>;
    }
  };
  return (
    <NavLink
      to={`/candidate-applied-jobs`}
      state={{ candidateId, candidate }}
      // onClick={onClick}
      className="grid grid-cols-[1.4fr_1.1fr_0.5fr] gap-5 items-center py-5 border-b hover:bg-gray-50 "
    >
      <div className="flex flex-col gap-1 border-green-600 border-l-[4px] py-4 pl-6">
        <div className="flex items-center justify-between">
          <span className="text-[10px] text-light-black font-semibold">
            {candidate?.refNo || "-"}
          </span>
          <span
            className={`font-semibold text-xss ${isUnavailable ? "text-gray-500" : "text-green-600"}`}
          >
            {isUnavailable ? "Unavailable" : "Available to work"}
          </span>
        </div>
        <div
          className={`flex items-center gap-3 rounded-md py-2.5`}
        >
          <div className="w-[45px] h-[45px] bg-gray-100 rounded-full border">
            <img
              src={candidate?.profilePic || fallbackProfileImg}
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          <div className="flex flex-col gap-0.5 text-charcoal">
            <span className="text-md font-semibold line-clamp-1">{fullName}</span>
            <span className="text-xss font-medium text-light-black">
              {candidate?.jobTitle || "-"}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-5 h-[1rem] text-xss text-light-black">
          {latestTracker?.createdAt ? (
            <>
              <span className="font-semibold text-charcoal">{dayjs(latestTracker?.createdAt).format("hh:mm a")}</span>
              <span className="font-medium">{dayjs(latestTracker?.createdAt).format("DD MMM YYYY")}</span>
            </>
          ) : null}
        </div>

        <div className="flex items-center bg-[#fafafa] border border-gray-200 rounded-md h-[3.8rem] py-3 px-3">
          <span className="text-xss font-medium text-charcoal">
            {renderTrackerMessage()}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-center gap-4">
        <div className="flex flex-col items-center text-xsss gap-2 font-semibold">
          <div className="relative w-[53px] h-[53px] flex items-center justify-center">
            {/* Glow layer */}
            {/* {data?.unViewedApplicants ? (
                        <span className="absolute inset-0 rounded-full bg-green-500 opacity-5 animate-pulse"></span>
                    ) : null} */}

            {/* Badge */}
            <div
              className={`relative z-10 w-[53px] h-[53px] rounded-full border-[3.5px] ${
                data?.appliedJobCount
                  ? !isUnavailable
                    ? "border-green-500"
                    : "border-gray-500"
                  : "border-gray-500"
              } flex items-center justify-center`}
            >
              <span className="text-xs font-semibold text-black">
                {data?.appliedJobCount || 0}
              </span>
            </div>
          </div>
          Applied Jobs
        </div>
        <button className=" mt-5 w-10 h-10 rounded-md border border-light-grey flex items-center justify-center">
          <ArrowRight size={19} />
        </button>
      </div>
    </NavLink>
  );
};

export default CandidateRowCard;
